import { FormEvent } from "react"
import { createPortal } from "react-dom"
import { toast } from "react-toastify"
import { SerializedError } from "@reduxjs/toolkit"
import { FetchBaseQueryError } from "@reduxjs/toolkit/query"
import classNames from "classnames"
import styled from "styled-components"

import { useUpdateDeviceMessageStatusMutation } from "store/api/contractorsApi"
import { ApiTypes } from "types"
import styles from "assets/scss/index.module.scss"
import { ReactComponent as IconCancel } from "assets/svg/icon-close.svg"

import getErrorMessage from "utils/getErrorMessage"
import { ModalLayout } from "layouts/ModalLayout"
// import { RadioButton } from "components/form/RadioButton"

const ModalMessage = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: #475569;
`

const IconContainer = styled.span`
  width: 24px;
  height: 24px;
  display: inline-block;
  padding-top: 10px;
  background-color: #fee2e2;
  border-radius: 10px;
  width: 40px;
  height: 40px;

  svg {
    path {
      stroke: #b91c1c;
    }
  }
`

// const RadioButtonsWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   margin-top: 10px;
// `

// enum CancelOptionEnum {
//   THIS_ONLY = "this_only",
//   THIS_AND_FOLLOWING = "this_and_following",
// }

interface Props {
  deviceMessage: ApiTypes.Model.DeviceMessage | null
  onCancel: () => void
  onSuccess: () => void
}

const RepeatedMessageRemoveDescription =
  "If you have any recurring messages, they will also be canceled. Are you sure you want to cancel the scheduled message(s)?"
const SingleMessageRemoveDescription = "Are you sure you want to cancel the scheduled message?"

export const RemoveScheduledMessageModal = ({ deviceMessage, onCancel, onSuccess }: Props) => {
  // const [cancelNextDelivery, { isLoading: isCancelingNextDelivery }] = useCancelNextDeliveryMutation()
  const [updateDeviceMessageStatus, { isLoading: isUpdatingStatus }] = useUpdateDeviceMessageStatusMutation()
  // const [cancelOption, setCancelOption] = useState<CancelOptionEnum>(CancelOptionEnum.THIS_ONLY)

  const handleCancelMessage = async (mutationCall: () => Promise<unknown>) => {
    try {
      const res = (await mutationCall()) as { error?: SerializedError | FetchBaseQueryError }
      const error = getErrorMessage(res?.error)
      if (error) {
        toast.error(error)
      } else {
        toast.success("Scheduled message has been successfully cancelled!")
        onSuccess()
      }
    } catch (error) {
      console.error(error)
      toast.error("An error occurred while cancelling the scheduled message")
    }
  }

  const onSubmit = async (event: FormEvent<HTMLElement>) => {
    event.preventDefault()

    if (!deviceMessage) {
      toast.error("Device message is missing")
      return
    }

    // const shouldCancelAll =
    // deviceMessage.repeat_period === "never" || cancelOption === CancelOptionEnum.THIS_AND_FOLLOWING

    // if (shouldCancelAll) {
    await handleCancelMessage(() =>
      updateDeviceMessageStatus({
        id: deviceMessage.message_id,
        status: "canceled",
      }),
    )
    // } else {
    //   await handleCancelMessage(() =>
    //     cancelNextDelivery({
    //       id: deviceMessage.message_id,
    //       status: "canceled",
    //     }),
    //   )
    // }
  }

  // const handleRadioChange = (event: FormEvent<HTMLInputElement>) => {
  //   setCancelOption(event.currentTarget.value as CancelOptionEnum)
  // }

  return (
    <>
      {createPortal(
        <ModalLayout
          width="470px"
          // isFetching={isUpdatingStatus || isCancelingNextDelivery}
          isFetching={isUpdatingStatus}
          onConfirm={onSubmit}
          onCancel={onCancel}
          confirmButtonColor="red"
          confirmButtonText="Confirm"
        >
          <div className={classNames(styles.modalContent, styles.center)}>
            <IconContainer>
              <IconCancel />
            </IconContainer>
            <h3 className={styles.modalTitle}>Cancel scheduled message</h3>
            <ModalMessage>
              {deviceMessage?.repeat_period === "never"
                ? SingleMessageRemoveDescription
                : RepeatedMessageRemoveDescription}
            </ModalMessage>
            {/* {deviceMessage?.repeat_period !== "never" && (
              <RadioButtonsWrapper>
                <RadioButton
                  name="cancelOption"
                  value="this_only"
                  id="this_only"
                  isChecked={cancelOption === CancelOptionEnum.THIS_ONLY}
                  onChange={handleRadioChange}
                >
                  This message only
                </RadioButton>
                <RadioButton
                  name="cancelOption"
                  value="this_and_following"
                  id="this_and_following"
                  isChecked={cancelOption === CancelOptionEnum.THIS_AND_FOLLOWING}
                  onChange={handleRadioChange}
                >
                  This and following messages
                </RadioButton>
              </RadioButtonsWrapper>
            )} */}
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
